import FormPIIVerificationSuccessfulPopup from './popup';

const FormPIIVerificationSuccessfulModal = ({ isShow, modalData }) => {
  return (
    <FormPIIVerificationSuccessfulPopup
      isOpen={isShow}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1066}
      zIndexModal={1067}
      modalData={modalData}
    />
  );
};

export default FormPIIVerificationSuccessfulModal;
